import { Stack } from '@mui/material';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import ButtonBack from 'src/components/common/ButtonBack';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { TypeDataPackage } from 'src/utils/constants/enum';

const AnalyticsPackageHeader = () => {
  const { type_package = TypeDataPackage.top_20_export_company_in_country } = useQueryParams();
  const renderTitle = () => {
    switch (type_package) {
      case TypeDataPackage.top_20_export_company_in_country:
        return 'Top 20 Exporting Companies';
      case TypeDataPackage.top_20_import_company_in_country:
        return 'Top 20 Importing Companies';
      case TypeDataPackage.top_20_export_product_in_country:
        return 'Top 20 Most Exported Products';
      case TypeDataPackage.top_20_import_product_in_country:
        return 'Top 20 Most Imported Products';
      default:
        return 'Top 20 Trade Balance Analysis';
    }
  };

  return (
    <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
      <ButtonBack />

      <Breadcrumbs
        listItem={[
          {
            text: 'Trade Data Package',
          },
          {
            text: renderTitle(),
          },
        ]}
      />
    </Stack>
  );
};

export default AnalyticsPackageHeader;
